import VisitasAdmin from "./admin/visits/index";
import SalidasAdmin from "./admin/departures/index";
import List from "../pages/admin/visits/list";
import DepartureList from "../pages/admin/departures/list";
import Companies from "../pages/admin/company/index";
import CreateCompany from "../pages/admin/company/create";
import UpdateCompany from "../pages/admin/company/update";
import Reasons from "../pages/admin/departure_reasons/index";
import CreateReason from "../pages/admin/departure_reasons/create";
import UpdateReason from "../pages/admin/departure_reasons/update";
import Establishments from "../pages/admin/establishment/index";
import CreateEstablishment from "../pages/admin/establishment/create";
import UpdateEstablishment from "../pages/admin/establishment/update";
import Employees from "../pages/admin/employee/index";
import LogsEmployees from "../pages/admin/employee/logs";
import LogsAffiliationsEmployees from "../pages/admin/employee/logs_affiliations";
import LogsAbsenceEmployees from "../pages/admin/employee/logs_absence";
import CreateEmployee from "../pages/admin/employee/create";
import Import from '../pages/admin/employee/import';
import UpdateEmployee from "../pages/admin/employee/update";
import Supplier from "../pages/admin/supplier/index";
import UpdateSupplier from '../pages/admin/supplier/update';
import CreateSupplier from "../pages/admin/supplier/create";
import Visitant from "../pages/admin/visitant/index";
import UpdateVisitant from "../pages/admin/visitant/update";
import CreateVisitant from "../pages/admin/visitant/create";
import Users from "../pages/admin/users/index";
import CreateUser from "../pages/admin/users/create";
import UpdateUser from "../pages/admin/users/update";
import Jobs from '../pages/admin/job/index';
import CreateJob from '../pages/admin/job/create';
import VisitDetails from '../pages/admin/visits/details';
import DepartureDetails from '../pages/admin/departures/details';
import SalidasMonitoreo from '../pages/admin/departures/index-monitoring';
import UpdateJob from '../pages/admin/job/update';
import GroupList from '../pages/admin/groups/index';
import CreateGroup from '../pages/admin/groups/create';
import UpdateGroup from '../pages/admin/groups/update';
import EmailZonesList from '../pages/admin/email_zones/index';
import UpdateEmailZone from '../pages/admin/email_zones/update';
import Zones from "../pages/admin/zones/index";
import CreateZone from "../pages/admin/zones/create";
import UpdateZone from "../pages/admin/zones/update";
import EmailSettingList from "../pages/admin/email_settings";
import ReasonDismissalList from "../pages/admin/reason_dismissal";
import IncomeAdmin from "../pages/admin/income/index"
import IncomeList from "../pages/admin/income/list"
import IncomeDetails from '../pages/admin/income/details';
import ReasonsDeclineList from "../pages/admin/reasons_decline/index"
import BanksList from "../pages/admin/banks/index";
import Sections from "./admin/sections";
import UpdateSection from "./admin/sections/update";
import UpdateGroupSection from "./admin/groups_sections/update";
import EmployeesForms from "./admin/employee/datas";
import EmployeeDatas from "./admin/employee/item-datas";
import Statistics from "./admin/statistics/index";
import ReasonMovementList from "./admin/reason_movement";
import TypeNoveltyList from "./admin/type_novelty";
import OperatorList from "./admin/operator";
import NoveltyList from "./admin/novelty";
import Supervisor from "./admin/supervisor";
import Turn from "./admin/turn";
import NotesAdmin from "./admin/notes";
import TypeCustodyList from "./admin/type_custody";
import CustodianList from "./admin/custodian";
import CustodyAdmin from "./admin/custody";
import Bonus from "./admin/bonus";
import ImportBonus from "./admin/bonus/import_bonus";
import TypeShippingRequestList from "./admin/type_shipping_request";
import ShippingRequestList from "./admin/shipping_request";
import ReasonShippingRequest from "./admin/reason_shipping_request";
import ReasonMaintenance from "./admin/reason_maintenance";
import TypeMaintenance from "./admin/type_maintenance";
import MaintenanceAdmin from "./admin/maintenance";
import MaintenanceSurvey from "./admin/maintenance_survey";
import UpdateMaintenanceSurvey from "./admin/maintenance_survey/update";
import ReasonPurchases from "./admin/reason_purchases";
import Product from "./admin/products";
import PurchaseAdmin from "./admin/purchases";
import Vehicle from "./admin/vehicles";
import UpdateVehicle from "./admin/vehicles/update";
import Services from "./admin/services";
import VehicleMaintenance from "./admin/vehicle_maintenance";
import UpdateVehicleMaintenance from "./admin/vehicle_maintenance/update";
import MaintenanceSupplier from "./admin/maintenance_supplier";
import CategoryMaintenance from "./admin/categories_maintenance";
import ProductType from "./admin/product_types";
import Vehicles from "./admin/vehicles/vehicles";
import NoveltyVehicleMaintenanceAdmin from "./admin/novelty_vehicle_maintenance";
import SalidasPersonales from "./admin/departures/index-admin";
import VacanciesNotification from "./admin/vacancies_notification";
import VacanciesAdmin from "./admin/vacancies";
import QRConfiguration from "./admin/qr_configuration";

// import Help from '../pages/admin/help/index'
// import HelpDetail from '../pages/admin/help/detail'

const routes = [
    {
        path: "/",
        name: "salidas Admin",
        exact: true,
        is_header: false,
        component: SalidasAdmin,
        show_in_menu: true,
        icon: "bx bx-home-alt",
        meta: {
            requiresAuth: true,
            title: "Salidas",
            permission_required: [
                'view_employeedepartures' &&
                'aprove_departures'
            ],
        },
    },
    {
        path: "/",
        name: "salidas",
        exact: true,
        is_header: false,
        component: DepartureList,
        show_in_menu: true,
        icon: "bx bx-home-alt",
        meta: {
            requiresAuth: true,
            title: "Salidas",
            permission_required: [
                'add_employeedepartures',
            ],
        },
    },
    {
        path: "/",
        name: "visitas-salidas-monitoreo",
        exact: true,
        is_header: false,
        component: SalidasMonitoreo,
        show_in_menu: true,
        icon: "bx bx-home-alt",
        meta: {
            requiresAuth: true,
            title: "Monitoreo",
            permission_required: [
                'response_exit', "can_approve_visit"
            ],
        },
    },
    {
        path: "/salidas-personales",
        name: "salidas gestion humana",
        exact: true,
        is_header: false,
        component: SalidasPersonales,
        show_in_menu: true,
        icon: "bx bx-home-alt",
        meta: {
            requiresAuth: true,
            title: "Permisos",
            permission_required: [
                'personal_departures'
            ],
        },
    },
    {
        path: "/salidas/:departure_id",
        name: "salidas",
        exact: true,
        is_header: false,
        component: DepartureDetails,
        show_in_menu: false,
        icon: "bx bx-home-alt",
        meta: {
            requiresAuth: true,
            title: "Salidas",
            permission_required: [
                "view_employeedepartures",

            ],
        },
    },
    {
        path: "/ingresos-tiendas",
        name: "ingresos",
        exact: true,
        is_header: false,
        component: IncomeAdmin,
        show_in_menu: true,
        icon: "bx bx-home-alt",
        meta: {
            requiresAuth: true,
            title: "Ingresos a tiendas",
            permission_required: [
                "view_income"
            ],
        },
    },
    {
        path: "/ingreso-tienda",
        name: "ingresos",
        exact: true,
        is_header: false,
        component: IncomeList,
        show_in_menu: true,
        icon: "bx bx-home-alt",
        meta: {
            requiresAuth: true,
            title: "Ingresos a tiendas",
            permission_required: [
                "add_income"
            ],
        },
    },
    {
        path: "/ingreso-tienda/:id",
        name: "ingresos",
        exact: true,
        is_header: false,
        component: IncomeDetails,
        show_in_menu: false,
        icon: "bx bx-home-alt",
        meta: {
            requiresAuth: true,
            title: "Ingresos a tiendas",
            permission_required: [
                "add_income"
            ],
        },
    },
    {
        path: "/visitas",
        name: "visitas",
        exact: true,
        is_header: false,
        component: VisitasAdmin,
        show_in_menu: true,
        icon: "bx bx-home-alt",
        meta: {
            requiresAuth: true,
            title: "Visitas",
            permission_required: [
                "add_visits",
                'can_approve_visit' &&
                'aprove_departures'
            ],
        },
    },
    {
        path: "/visitas",
        name: "visitas",
        exact: true,
        is_header: false,
        component: List,
        show_in_menu: true,
        icon: "bx bx-home-alt",
        meta: {
            requiresAuth: true,
            title: "Visitas",
            permission_required: [
                'can_add_no_scheduled_visit',
            ],
        },
    },
    {
        path: "/visitas/:id",
        name: "visitas",
        exact: true,
        is_header: false,
        component: VisitDetails,
        show_in_menu: false,
        icon: "bx bx-home-alt",
        meta: {
            requiresAuth: true,
            title: "Visitas",
            permission_required: [
                "view_visits",
                "can_add_no_scheduled_visit"
            ],
        },
    },
    {
        path: "/custodias",
        name: "custodias",
        exact: true,
        is_header: false,
        component: CustodyAdmin,
        show_in_menu: true,
        icon: "bx bx-home-alt",
        meta: {
            requiresAuth: true,
            title: "Custodias",
            permission_required: [
                'view_custody',
            ],
        },
    },
    {
        path: "/novedades",
        name: "novedades",
        exact: true,
        is_header: false,
        component: NoveltyList,
        show_in_menu: true,
        icon: "bx bx-news",
        meta: {
            requiresAuth: true,
            title: "Novedades",
            permission_required: [
                "view_novelty"
            ],
        },
    },
    {
        path: "/notas",
        name: "notas",
        exact: true,
        is_header: false,
        component: NotesAdmin,
        show_in_menu: true,
        icon: "bx bx-notepad",
        meta: {
            requiresAuth: true,
            title: "Notas",
            permission_required: [
                "view_note"
            ],
        },
    },
    {
        path: "/solicitudes-envios",
        name: "solicitudes-envios",
        exact: true,
        is_header: false,
        icon: "bx bx-mail-send",
        component: ShippingRequestList,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Solicitudes",
            permission_required: [
                "view_shippingrequest",
            ],
        },
    },
    {
        path: "/mantenimientos",
        name: "mantenimientos",
        exact: true,
        is_header: false,
        icon: "bx bxs-cog",
        component: MaintenanceAdmin,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Mantenimientos",
            permission_required: [
                "view_maintenance",
            ],
        },
    },
    {
        path: "/mantenimientos-vehiculares",
        name: "mantenimientos-vehiculares",
        exact: true,
        is_header: false,
        icon: "bx bxs-car",
        component: Vehicles,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Mantenimientos (vehículos)",
            permission_required: [
                "view_itemsvehiclemaintenance",
            ],
        },
    },
    {
        path: "/novedades-mantenimientos",
        name: "novedades-mantenimientos",
        exact: true,
        is_header: false,
        icon: "bx bx-note",
        component: NoveltyVehicleMaintenanceAdmin,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Novedades de mantenimientos",
            permission_required: [
                "view_noveltyvehiclemaintenance",
            ],
        },
    },
    {
        path: "/compras",
        name: "compras",
        exact: true,
        is_header: false,
        icon: "bx bxs-cart",
        component: PurchaseAdmin,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Compras",
            permission_required: [
                "view_purchases",
            ],
        },
    },
    {
        path: "/vacantes",
        name: "vacantes",
        exact: true,
        is_header: false,
        component: VacanciesAdmin,
        icon: "bx bx-mail-send",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Vacantes",
            permission_required: [
                "view_vacancies",
            ],
        },
    },
    {
        path: "/estadisticas",
        name: "estadisticas",
        exact: true,
        is_header: false,
        component: Statistics,
        icon: "bx bxs-bar-chart-alt-2",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Estadísticas",
            permission_required: [
                "statistics_departures",
            ],
        },
    },
    {
        path: "/empresas",
        name: "empresas",
        exact: true,
        is_header: false,
        component: Companies,
        icon: "bx bxs-city",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Empresas",
            permission_required: [
                "view_company",
            ],
        },
    },
    {
        path: "/empresas/crear",
        name: "empresas",
        exact: true,
        is_header: false,
        component: CreateCompany,
        icon: "bx bxs-city",
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Empresas",
            permission_required: [
                "add_company",
            ],
        },
    },
    {
        path: "/empresas/editar/:id",
        name: "empresas",
        exact: true,
        is_header: false,
        component: UpdateCompany,
        icon: "bx bxs-city",
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Empresas",
            permission_required: [
                "change_company",
            ],
        },
    },
    {
        path: "/razones",
        name: "razones",
        exact: true,
        is_header: false,
        component: Reasons,
        icon: "bx bxs-book",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Razones",
            permission_required: [
                "view_reasons",
            ],
        },
    },
    {
        path: "/razones/crear",
        name: "razones",
        exact: true,
        is_header: false,
        component: CreateReason,
        icon: "bx bxs-city",
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Razones",
            permission_required: [
                "add_reasons",
            ],
        },
    },
    {
        path: "/razones/editar/:id",
        name: "razones",
        exact: true,
        is_header: false,
        component: UpdateReason,
        icon: "bx bxs-city",
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Razones",
            permission_required: [
                "change_reasons",
            ],
        },
    },
    {
        path: "/zonas-correos",
        name: "correos",
        exact: true,
        is_header: false,
        component: EmailZonesList,
        icon: "bx bx-mail-send",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Zonas - Correos",
            permission_required: [
                "view_email",
            ],
        },
    },
    {
        path: "/zona-correo/editar/:id",
        name: "correos",
        exact: true,
        is_header: false,
        component: UpdateEmailZone,
        icon: "bx bx-mail-send",
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Zonas - Correos",
            permission_required: [
                "change_email",
            ],
        },
    },
    {
        path: "/zonas",
        name: "zonas",
        exact: true,
        is_header: false,
        component: Zones,
        icon: "bx bx-map-pin",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Zonas",
            permission_required: [
                "view_zones",
            ],
        },
    },
    {
        path: "/zona/crear",
        name: "zonas",
        exact: true,
        is_header: false,
        component: CreateZone,
        icon: "bx bx-map-pin",
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Zonas",
            permission_required: [
                "add_zones",
            ],
        },
    },
    {
        path: "/zona/editar/:id",
        name: "zonas",
        exact: true,
        is_header: false,
        component: UpdateZone,
        icon: "bx bx-map-pin",
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Zonas",
            permission_required: [
                "change_zones",
            ],
        },
    },
    {
        path: "/cargos",
        name: "cargos",
        exact: true,
        is_header: false,
        component: Jobs,
        icon: "bx bxs-briefcase",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Cargos",
            permission_required: [
                "view_job",
            ],
        },
    },
    {
        path: "/cargos/crear",
        name: "cargos",
        exact: true,
        is_header: false,
        component: CreateJob,
        icon: "bx bxs-briefcase",
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Cargos",
            permission_required: [
                "add_job",
            ],
        },
    },
    {
        path: "/cargos/editar/:id",
        name: "cargos",
        exact: true,
        is_header: false,
        component: UpdateJob,
        icon: "bx bxs-briefcase",
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Cargos",
            permission_required: [
                "change_job",
            ],
        },
    },
    {
        path: "/establecimientos",
        name: "establecimientos",
        exact: true,
        is_header: false,
        component: Establishments,
        icon: "bx bxs-store-alt",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Establecimientos",
            permission_required: [
                "view_establishments",
            ],
        },
    },
    {
        path: "/establecimientos/crear",
        name: "establecimientos",
        exact: false,
        component: CreateEstablishment,
        icon: "bx bxs-store-alt",
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Establecimiento",
            permission_required: [
                "add_establishments",
            ],
        },
    },
    {
        path: "/Establecimientos/editar/:id",
        name: "establecimientos",
        exact: true,
        is_header: false,
        component: UpdateEstablishment,
        icon: "bx bxs-store-alt",
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Establecimiento",
            permission_required: [
                "change_establishments",
            ],
        },
    },
    {
        path: "/empleados",
        name: "empleados",
        exact: true,
        is_header: false,
        icon: "bx bxs-group",
        component: Employees,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Empleados",
            permission_required: [
                "view_employees",
            ],
        },
    },
    {
        path: "/empleados/crear",
        name: "empleados",
        exact: false,
        icon: "bx bxs-group",
        component: CreateEmployee,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Empleados",
            permission_required: [
                "update_employing_company",
            ],
        },
    },
    {
        path: "/empleados/importar",
        name: "empleados",
        exact: false,
        icon: "bx bxs-group",
        component: Import,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Empleados",
            permission_required: [
                "update_employing_company",
            ],
        },
    },
    {
        path: "/empleados/editar/:id",
        name: "empleados",
        exact: true,
        is_header: false,
        icon: "bx bxs-group",
        component: UpdateEmployee,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Empleados",
            permission_required: [
                "change_employees" ||
                "update_employing_company"
            ],
        },
    },
    {
        path: "/empleados-formularios",
        name: "empleados-formularios",
        exact: true,
        is_header: false,
        icon: "bx bxs-group",
        component: EmployeesForms,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Consulta de datos",
            permission_required: [
                "view_forms",
            ],
        },
    },
    {
        path: "/empleado/datos/:id",
        name: "empleados-formularios",
        exact: true,
        is_header: false,
        icon: "bx bxs-group",
        component: EmployeeDatas,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Consulta de datos",
            permission_required: [
                "view_forms",
            ],
        },
    },
    {
        path: "/bonificaciones",
        name: "bonificaciones",
        exact: true,
        is_header: false,
        icon: "bx bxs-user-detail",
        component: Bonus,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Bonificaciones",
            permission_required: [
                "view_bonus",
            ],
        },
    },
    {
        path: "/bonificaciones/importar",
        name: "bonificaciones",
        exact: false,
        icon: "bx bxs-group",
        component: ImportBonus,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Bonificaciones",
            permission_required: [
                "add_bonus",
            ],
        },
    },
    {
        path: "/tipos-solicitudes-envios",
        name: "tipos-solicitudes-envios",
        exact: true,
        is_header: false,
        icon: "bx bxs-notepad",
        component: TypeShippingRequestList,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Tipos solicitudes",
            permission_required: [
                "view_typeshippingrequest",
            ],
        },
    },
    {
        path: "/motivos-solicitudes-envios",
        name: "motivos-solicitudes-envios",
        exact: true,
        is_header: false,
        icon: "bx bxs-note",
        component: ReasonShippingRequest,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Motivos de solicitudes",
            permission_required: [
                "view_reasonshippingrequest",
            ],
        },
    },
    {
        path: "/categorias-mantenimientos",
        name: "categorias-mantenimientos",
        exact: true,
        is_header: false,
        icon: "bx bx-check-circle",
        component: CategoryMaintenance,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Categorías de mantenimientos",
            permission_required: [
                "view_categories",
            ],
        },
    },
    {
        path: "/tipos-mantenimientos",
        name: "tipos-mantenimientos",
        exact: true,
        is_header: false,
        icon: "bx bxs-bolt-circle",
        component: TypeMaintenance,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Tipos mantenimientos",
            permission_required: [
                "view_typemaintenance",
            ],
        },
    },
    {
        path: "/motivos-mantenimientos",
        name: "motivos-mantenimientos",
        exact: true,
        is_header: false,
        icon: "bx bx-columns",
        component: ReasonMaintenance,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Motivos de mantenimientos",
            permission_required: [
                "view_reasonmaintenance",
            ],
        },
    },
    {
        path: "/encuestas-mantenimientos",
        name: "encuestas-mantenimientos",
        exact: true,
        is_header: false,
        icon: "bx bx-edit",
        component: MaintenanceSurvey,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Encuestas de mantenimientos",
            permission_required: [
                "view_maintenancesurvey",
            ],
        },
    },
    {
        path: "/encuesta-mantenimiento/editar/:id",
        name: "encuestas-mantenimientos",
        exact: true,
        is_header: false,
        icon: "bx bxs-truck",
        component: UpdateMaintenanceSurvey,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Encuestas de mantenimientos",
            permission_required: [
                "change_maintenancesurvey",
            ],
        },
    },
    {
        path: "/tipos-productos",
        name: "tipos-productos",
        exact: true,
        is_header: false,
        icon: "bx bxs-bookmark",
        component: ProductType,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Tipos de productos",
            permission_required: [
                "view_producttypes",
            ],
        },
    },
    {
        path: "/productos",
        name: "productos",
        exact: true,
        is_header: false,
        icon: "bx bxl-product-hunt",
        component: Product,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Productos",
            permission_required: [
                "view_products",
            ],
        },
    },
    {
        path: "/motivos-compras",
        name: "motivos-compras",
        exact: true,
        is_header: false,
        icon: "bx bx-columns",
        component: ReasonPurchases,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Motivos de compras",
            permission_required: [
                "view_reasonpurchases",
            ],
        },
    },
    {
        path: "/historia-empleados",
        name: "historia-empleados",
        exact: true,
        is_header: false,
        icon: "bx bxs-user-detail",
        component: LogsEmployees,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Historial de empleados",
            permission_required: [
                "view_employees",
            ],
        },
    },
    {
        path: "/afiliaciones-empleados",
        name: "afiliaciones-empleados",
        exact: true,
        is_header: false,
        icon: "bx bxs-contact",
        component: LogsAffiliationsEmployees,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Historial de afiliaciones",
            permission_required: [
                "update_employing_company",
            ],
        },
    },
    {
        path: "/ausencia-empleados",
        name: "ausencia-empleados",
        exact: true,
        is_header: false,
        icon: "bx bxs-calendar",
        component: LogsAbsenceEmployees,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Historial de ausencias",
            permission_required: [
                "registrar_ausencia",
            ],
        },
    },
    {
        path: "/configuraciones-correos",
        name: "configuraciones-correos",
        exact: true,
        is_header: false,
        component: EmailSettingList,
        icon: "bx bx-mail-send",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Configuración de correos",
            permission_required: [
                "view_emailsettings",
            ],
        },
    },
    {
        path: "/motivos-despidos",
        name: "motivos-despidos",
        exact: true,
        is_header: false,
        component: ReasonDismissalList,
        icon: "bx bxs-detail",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Motivos de despidos",
            permission_required: [
                "view_reasondismissal",
            ],
        },
    },
    {
        path: "/motivos-movimientos",
        name: "motivos-movimientos",
        exact: true,
        is_header: false,
        component: ReasonMovementList,
        icon: "bx bxs-dashboard",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Motivos",
            permission_required: [
                "view_reasonmovement",
            ],
        },
    },
    {
        path: "/proveedores",
        name: "proveedores",
        exact: true,
        is_header: false,
        icon: "bx bxs-truck",
        component: Supplier,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Proveedores",
            permission_required: [
                "view_supplier",
            ],
        },
    },
    {
        path: "/proveedores/crear",
        name: "proveedores",
        exact: false,
        icon: "bx bxs-truck",
        component: CreateSupplier,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Proveedores",
            permission_required: [
                "add_supplier",
            ],
        },
    },
    {
        path: "/proveedores/editar/:id",
        name: "proveedores",
        exact: true,
        is_header: false,
        icon: "bx bxs-truck",
        component: UpdateSupplier,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Proveedores",
            permission_required: [
                "change_supplier",
            ],
        },
    },
    {
        path: "/invitados",
        name: "invitados",
        exact: true,
        is_header: false,
        icon: "bx bxs-user-detail",
        component: Visitant,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Invitados",
            permission_required: [
                "view_visitant",
            ],
        },
    },
    {
        path: "/invitados/crear",
        name: "invitados",
        exact: false,
        icon: "bx bxs-user-detail",
        component: CreateVisitant,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Invitados",
            permission_required: [
                "add_visitant",
            ],
        },
    },
    {
        path: "/invitados/editar/:id",
        name: "invitados",
        exact: true,
        is_header: false,
        icon: "bx bxs-user-detail",
        component: UpdateVisitant,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Invitados",
            permission_required: [
                "change_visitant",
            ],
        },
    },
    {
        path: "/motivos-rechazos",
        name: "motivos-rechazos",
        exact: true,
        is_header: false,
        component: ReasonsDeclineList,
        icon: "bx bxs-notepad",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Motivo de rechazo",
            permission_required: [
                "view_reasonsdecline",
            ],
        },
    },
    {
        path: "/bancos",
        name: "bancos",
        exact: true,
        is_header: false,
        component: BanksList,
        icon: "bx bxs-bank",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Bancos",
            permission_required: [
                "view_banks",
            ],
        },
    },
    {
        path: "/tipos-novedades",
        name: "tipos-novedades",
        exact: true,
        is_header: false,
        component: TypeNoveltyList,
        icon: "bx bx-list-ul",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Tipos de novedades",
            permission_required: [
                "view_typenovelty",
            ],
        },
    },
    {
        path: "/operarios",
        name: "operarios",
        exact: true,
        is_header: false,
        component: OperatorList,
        icon: "bx bxs-user-detail",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Operarios",
            permission_required: [
                "view_operator",
            ],
        },
    },
    {
        path: "/supervisor",
        name: "supervisor",
        exact: true,
        is_header: false,
        component: Supervisor,
        icon: "bx bxs-user-plus",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Supervisor",
            permission_required: [
                "view_supervisor",
            ],
        },
    },
    {
        path: "/turnos",
        name: "turnos",
        exact: true,
        is_header: false,
        component: Turn,
        icon: "bx bxs-label",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Turnos",
            permission_required: [
                "view_turn",
            ],
        },
    },
    {
        path: "/tipos-custodias",
        name: "tipos-custodias",
        exact: true,
        is_header: false,
        component: TypeCustodyList,
        icon: "bx bxs-customize",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Tipos de custodias",
            permission_required: [
                "view_typecustody",
            ],
        },
    },
    {
        path: "/custodiadores",
        name: "custodiadores",
        exact: true,
        is_header: false,
        component: CustodianList,
        icon: "bx bxs-user-circle",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Custodiadores",
            permission_required: [
                "view_custodian",
            ],
        },
    },
    {
        path: "/vehiculos",
        name: "vehiculos",
        exact: true,
        is_header: false,
        component: Vehicle,
        icon: "bx bxs-car",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Vehículos",
            permission_required: [
                "view_vehicles",
            ],
        },
    },
    {
        path: "/vehiculo/editar/:id",
        name: "vehiculos",
        exact: true,
        is_header: false,
        icon: "bx bxs-car",
        component: UpdateVehicle,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Vehículos",
            permission_required: [
                "add_vehicles",
                "change_vehicles",
            ],
        },
    },
    {
        path: "/servicios",
        name: "servicios",
        exact: true,
        is_header: false,
        component: Services,
        icon: "bx bxs-spreadsheet",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Servicios",
            permission_required: [
                "view_services",
            ],
        },
    },
    {
        path: "/proveedores-mantenimientos",
        name: "proveedores-mantenimientos",
        exact: true,
        is_header: false,
        component: MaintenanceSupplier,
        icon: "bx bxs-user-badge",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Proveedores mantenimientos",
            permission_required: [
                "view_maintenancesupplier",
            ],
        },
    },
    {
        path: "/mantenimientos-vehiculos",
        name: "mantenimientos-vehiculos",
        exact: true,
        is_header: false,
        component: VehicleMaintenance,
        icon: "bx bxs-checkbox-checked",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Mantenimientos del vehículo",
            permission_required: [
                "view_vehiclemaintenance",
            ],
        },
    },
    {
        path: "/mantenimiento/vehiculo/editar/:id",
        name: "mantenimientos-vehiculos",
        exact: true,
        is_header: false,
        icon: "bx bxs-checkbox-checked",
        component: UpdateVehicleMaintenance,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Mantenimientos del vehículo",
            permission_required: [
                "add_vehiclemaintenance",
                "change_vehiclemaintenance",
            ],
        },
    },
    {
        path: "/notificaciones-vacantes",
        name: "notificaciones-vacantes",
        exact: true,
        is_header: false,
        component: VacanciesNotification,
        icon: "bx bx-mail-send",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Notificaciones de vacantes",
            permission_required: [
                "view_vacanciesnotification",
            ],
        },
    },
    // {
    //     path: "",
    //     name: "",
    //     icon: "bx bxs-user",
    //     exact: true,
    //     is_header: true,
    //     component: null,
    //     show_in_menu: true,
    //     meta: {
    //         requiresAuth: true,
    //         title: "Usuarios",
    //         permission_required: [],
    //     },
    // },
    {
        path: "/configuracion-qr",
        name: "configuracion-qr",
        exact: true,
        is_header: false,
        component: QRConfiguration,
        icon: "bx bxs-file",
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Configuración de archivo QR",
            permission_required: [
                "view_qrconfiguration",
            ],
        },
    },
    {
        path: "/roles",
        name: "roles",
        icon: "bx bxs-user-pin",
        exact: true,
        is_header: false,
        component: GroupList,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Roles",
            permission_required: [
                "view_group",
            ],
        },
    },
    {
        path: "/roles/crear",
        name: "roles",
        icon: "bx bxs-user",
        exact: true,
        is_header: false,
        component: CreateGroup,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Roles",
            permission_required: [
                "add_group",
            ],
        },
    },
    {
        path: "/roles/editar/:id",
        name: "roles",
        icon: "bx bxs-user",
        exact: true,
        is_header: false,
        component: UpdateGroup,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Roles",
            permission_required: [
                "change_group",
            ],
        },
    },
    {
        path: "/usuarios",
        name: "usuarios",
        icon: "bx bxs-user",
        exact: true,
        is_header: false,
        component: Users,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Usuarios",
            permission_required: [
                "view_user",
            ],
        },
    },
    {
        path: "/usuarios/crear",
        name: "usuarios",
        icon: "bx bxs-user",
        exact: true,
        is_header: false,
        component: CreateUser,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Usuarios",
            permission_required: [
                "add_user",
            ],
        },
    },
    {
        path: "/usuarios/editar/:id",
        name: "usuarios",
        icon: "bx bxs-user",
        exact: true,
        is_header: false,
        component: UpdateUser,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Usuarios",
            permission_required: [
                "change_user",
            ],
        },
    },
    {
        path: "/secciones",
        name: "secciones",
        icon: "bx bx-list-ul",
        exact: true,
        is_header: false,
        component: Sections,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Formularios",
            permission_required: [
                "view_sections",
            ],
        },
    },
    {
        path: "/seccion/detalle/:id",
        name: "secciones",
        icon: "bx bx-list-ul",
        exact: true,
        is_header: false,
        component: UpdateSection,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Formularios",
            permission_required: [
                "change_sections",
            ],
        },
    },
    {
        path: "/seccion/grupo/:id_section/:id_group",
        name: "grupos",
        icon: "bx bxs-user-plus",
        exact: true,
        is_header: false,
        component: UpdateGroupSection,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Grupos",
            permission_required: [
                "change_sections",
            ],
        },
    },

    /*{
      path: "/ayuda/",
      name: "ayuda",
      icon: "bx bxs-info-circle",
      exact: true,
      component: Help,
      show_in_menu: true,
      meta: {
        requiresAuth: false,
        title: "Ayuda",
        permission_required: [
          "change_user",
        ],
      },
    },
    {
      path: "/detalle/:id",
      name: "ayuda",
      icon: "bx bxs-info-circle",
      exact: true,
      component: HelpDetail,
      show_in_menu: false,
      meta: {
        requiresAuth: false,
        title: "Ayuda",
        permission_required: [
          "change_user",
        ],
      },
    }*/
];

export default routes;
